<script>

import {groupBy} from 'lodash'

export default {
  props: {
    action: {
      type: Object
    },
    inputName: {},
    collection: {
      type: Array
    }
  },

  data() {
    return {
      showSelect: !(this.action.static_params && this.action.static_params[this.inputName])
    }
  },

  computed: {
    forceTextInput() {
      return this.collection.length == 0
    },

    groupedCollection() {
      return _.groupBy(this.collection, (item) => {
        return item.action.name
      })
    }
  }


}
</script>

<template>
  <div class="columns">
    <div class="column is-4">
      <b-tag>
        <span class="mono">{{ inputName }}</span>
      </b-tag>
    </div>

    <div class="column is-1 has-text-right">
      <b-field position="is-centered" v-if="!forceTextInput">
        <p class="control">
          <b-button @click="showSelect = true" size="is-small" :type="{'is-primary': showSelect}" icon-left="format-list-bulleted"></b-button>
        </p>
        <p class="control">
          <b-button @click="showSelect = false" size="is-small" :type="{'is-primary': !showSelect}" icon-left="card-text-outline"></b-button>
        </p>
      </b-field>
    </div>


    <div class="column">
      <b-input size="is-small" v-if="forceTextInput || !showSelect" v-model="action.static_params[inputName]" placeholder="Static value"></b-input>
      <b-select size="is-small" expanded v-model="action.input_mapping[inputName]" v-else>

        <optgroup v-for="(options, label) in groupedCollection" :label="label">
          <option v-for="output in options" :value="output.id" :key="output.id">
            {{ output.output }}
          </option>
        </optgroup>

      </b-select>


    </div>
  </div>
</template>

<style lang="scss">
.mono {
  font-family: monospace;
}
</style>